export default __webpack_public_path__ + "static/media/Flag_of_Cambodia.41cc7cdc.svg";